export function CheckCircleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm5.268 7.64a1 1 0 10-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 00-1.162 1.627l4.255 3.04 5.594-6.714z"
      ></path>
    </svg>
  );
}
